import { render, staticRenderFns } from "./indexLiveStream.vue?vue&type=template&id=9edf0d20&scoped=true&"
import script from "./indexLiveStream.vue?vue&type=script&lang=js&"
export * from "./indexLiveStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edf0d20",
  null
  
)

export default component.exports